import type { UserRevokedAction } from '@Application/Security/Authentications/Actions/userRevoked';
import type { UserPermissionsFetchedAction } from '@Application/Security/Roles/Actions/userPermissionsFetched';
import type { UserPermissionsFetchFailedAction } from '@Application/Security/Roles/Actions/userPermissionsFetchFailed';
import PermissionsListView from '@UI/Store/UserPermissions/Views/PermissionsListView';
import { createSliceReducer, registerStore } from '@verclam/synapse';

export type UserPermissionsStore = {
	permissions: PermissionsListView | null;
};

const initialState: UserPermissionsStore = {
	permissions: null,
};

type Actions = UserPermissionsFetchedAction | UserPermissionsFetchFailedAction | UserRevokedAction;

const whenUserPermissionsFetched = (
	store: UserPermissionsStore,
	action: UserPermissionsFetchedAction,
): UserPermissionsStore => ({
	...store,
	permissions: new PermissionsListView(action.payload),
});

// A failed fetch leaves the gate closed (`permissions: null`), never a stale or partial list.
const whenUserPermissionsFetchFailed = (): UserPermissionsStore => ({
	permissions: null,
});

const whenUserRevoked = (): UserPermissionsStore => initialState;

export default registerStore<'userPermissionsStore', Actions>(
	'userPermissionsStore',
	createSliceReducer({
		USER_PERMISSIONS_FETCHED: whenUserPermissionsFetched,
		USER_PERMISSIONS_FETCH_FAILED: whenUserPermissionsFetchFailed,
		USER_REVOKED: whenUserRevoked,
	}),
	initialState,
);
